import React, { useState, useEffect } from 'react';
import { getAllExtraMaterial } from 'services/course/extra-material';
import ExtraMaterial from 'services/course/models/extra-material-interface';
import { SectionContainer } from 'components/Container';
import { SupportMaterialWrapper, CardsContainer, Card, MainBtn } from './style';

import Seta from 'assets/icon/seta.svg';

const SupportMaterial: React.FC = () => {
  const [supportMaterial, setSupportMaterial] = useState<Array<ExtraMaterial>>(
    [],
  );

  useEffect(() => {
    (async () => {
      const allExtraMaterial = await getAllExtraMaterial();
      if (allExtraMaterial?.length) {
        setSupportMaterial(allExtraMaterial);
      }
    })();
  }, []);

  return supportMaterial && supportMaterial.length ? (
    <SupportMaterialWrapper>
      <SectionContainer>
        <div className="title-support">
          <h1>Materiais de apoio</h1>
        </div>

        <CardsContainer>
          {supportMaterial.map((data: ExtraMaterial, index) => (
            <Card key={index}>
              <div className="material-image">
                {data.thumbnail ? (
                  <img src={data.thumbnail} alt="support" />
                ) : (
                  <div className="no-image"></div>
                )}
                <span className="material-type">{data.name}</span>
              </div>

              {data.info?.description && (
                <p className="material-description">{data.info.description}</p>
              )}

              <MainBtn
                href={data.reference}
                target="_blank"
                rel="noopener noreferrer"
              >
                Acesse agora <img src={Seta} alt="Arrow" />
              </MainBtn>
            </Card>
          ))}
        </CardsContainer>
      </SectionContainer>
    </SupportMaterialWrapper>
  ) : (
    <></>
  );
};

export default SupportMaterial;
